"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DocumentModel_1 = require("../../../../../DriveScout/API/models/DocumentModel");
var send_reminder_modal_html_1 = __importDefault(require("../../send-reminder-modal/send-reminder-modal.html"));
var send_reminder_modal_controller_1 = __importDefault(require("../../send-reminder-modal/send-reminder-modal.controller"));
var AdminViewDocumentInstanceController = /** @class */ (function () {
    function AdminViewDocumentInstanceController($state, $stateParams, $uibModal, DocumentInstanceModel, FlashService, UserService) {
        var _a;
        this.loading = true;
        this.submitting = false;
        this.document = null;
        this.completionByRole = {};
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$uibModal = $uibModal;
        this.DocumentInstanceModel = DocumentInstanceModel;
        this.FlashService = FlashService;
        this.UserService = UserService;
        this.documentId = parseInt($stateParams.id, 10);
        var currentUser = UserService.getCurrentUser();
        this.userId = currentUser.id;
        this.userRole = (_a = currentUser.role) === null || _a === void 0 ? void 0 : _a.type;
        this.init();
    }
    AdminViewDocumentInstanceController.prototype.init = function () {
        var _this = this;
        this.loading = true;
        this.DocumentInstanceModel.getDocument(this.documentId)
            .then(function (response) {
            var _a;
            _this.document = ((_a = response.data) === null || _a === void 0 ? void 0 : _a.document) || response.document || response;
            if (_this.document) {
                _this.completionByRole = _this.DocumentInstanceModel.getCompletionByRole(_this.document);
            }
            _this.loading = false;
        })
            .catch(function () {
            _this.FlashService.setMessage({ type: "error", message: "Failed to load document" });
            _this.loading = false;
        });
    };
    AdminViewDocumentInstanceController.prototype.goBack = function (reload) {
        if (reload === void 0) { reload = false; }
        this.$state.go("drivecoach.admin.documents", {}, { reload: reload });
    };
    AdminViewDocumentInstanceController.prototype.archiveDocument = function () {
        var _this = this;
        if (!this.document || !confirm("Are you sure you want to archive this document?")) {
            return;
        }
        this.submitting = true;
        this.DocumentInstanceModel.archiveDocument(this.document.id)
            .then(function () {
            _this.FlashService.setMessage({ type: "success", message: "Document archived successfully" });
            _this.goBack(true);
        })
            .catch(function () {
            _this.FlashService.setMessage({ type: "error", message: "Failed to archive document" });
        })
            .finally(function () {
            _this.submitting = false;
        });
    };
    AdminViewDocumentInstanceController.prototype.deleteDocument = function () {
        var _this = this;
        if (!this.document || !confirm("Are you sure you want to permanently delete this document? This action cannot be undone.")) {
            return;
        }
        this.submitting = true;
        (0, DocumentModel_1.DeleteDocument)(this.document.id)
            .then(function () {
            _this.FlashService.setMessage({ type: "success", message: "Document deleted successfully" });
            _this.goBack(true);
        })
            .catch(function (error) {
            var _a, _b;
            var message = ((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || "Failed to delete document";
            _this.FlashService.setMessage({ type: "error", message: message });
        })
            .finally(function () {
            _this.submitting = false;
        });
    };
    AdminViewDocumentInstanceController.prototype.sendReminder = function () {
        var _this = this;
        if (!this.document)
            return;
        var pendingUsers = this.document.assigned_users
            .filter(function (u) { return u.completion_status !== "completed"; });
        if (pendingUsers.length === 0) {
            this.FlashService.setMessage({ type: "info", message: "All assigned users have completed their fields" });
            return;
        }
        var modalInstance = this.$uibModal.open({
            animation: true,
            template: send_reminder_modal_html_1.default,
            controller: send_reminder_modal_controller_1.default,
            controllerAs: "vm",
            size: "md",
            resolve: {
                document: function () { return _this.document; },
                pendingUsers: function () { return pendingUsers; },
            },
        });
        modalInstance.result.then(function () {
            _this.FlashService.setMessage({ type: "success", message: "Reminder sent successfully" });
        }, function () {
            // dismissed
        });
    };
    AdminViewDocumentInstanceController.prototype.downloadPdf = function () {
        if (!this.document || !this.document.file_url) {
            this.FlashService.setMessage({ type: "error", message: "PDF not available" });
            return;
        }
        window.open(this.document.file_url, "_blank");
    };
    AdminViewDocumentInstanceController.prototype.generateFlattenedPdf = function () {
        var _this = this;
        if (!this.document || this.document.status !== "completed") {
            return;
        }
        this.submitting = true;
        (0, DocumentModel_1.RegeneratePdf)(this.document.id)
            .then(function (response) {
            var _a;
            var result = ((_a = response.data) === null || _a === void 0 ? void 0 : _a.data) || response.data;
            if (result && result.file_url) {
                _this.FlashService.setMessage({ type: "success", message: "PDF regenerated successfully." });
                window.open(result.file_url, "_blank");
            }
            else {
                _this.FlashService.setMessage({ type: "info", message: "PDF regenerated but no download URL was returned." });
            }
        })
            .catch(function (error) {
            var _a, _b;
            var message = ((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || "Failed to regenerate PDF";
            _this.FlashService.setMessage({ type: "error", message: message });
        })
            .finally(function () {
            _this.submitting = false;
        });
    };
    AdminViewDocumentInstanceController.prototype.downloadFlattenedPdf = function () {
        var _this = this;
        if (!this.document || this.document.status !== "completed") {
            this.FlashService.setMessage({ type: "error", message: "Completed PDF only available for completed documents" });
            return;
        }
        this.submitting = true;
        (0, DocumentModel_1.GetFlattenedPdf)(this.document.id)
            .then(function (response) {
            var _a;
            var result = ((_a = response.data) === null || _a === void 0 ? void 0 : _a.data) || response.data;
            if (result && result.file_url) {
                window.open(result.file_url, "_blank");
            }
            else {
                _this.FlashService.setMessage({ type: "error", message: "Completed PDF not yet available. Please try again later." });
            }
        })
            .catch(function (error) {
            var _a, _b;
            var message = ((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || "Failed to retrieve completed PDF";
            _this.FlashService.setMessage({ type: "error", message: message });
        })
            .finally(function () {
            _this.submitting = false;
        });
    };
    AdminViewDocumentInstanceController.prototype.handleSignatureAdded = function () {
        this.FlashService.setMessage({ type: "success", message: "Signature saved successfully" });
        this.reloadDocument();
    };
    AdminViewDocumentInstanceController.prototype.handleError = function (error) {
        this.FlashService.setMessage({ type: "error", message: error.message || "An error occurred" });
    };
    AdminViewDocumentInstanceController.prototype.reloadDocument = function () {
        var _this = this;
        this.DocumentInstanceModel.getDocument(this.documentId)
            .then(function (response) {
            var _a;
            _this.document = ((_a = response.data) === null || _a === void 0 ? void 0 : _a.document) || response.document || response;
            if (_this.document) {
                _this.completionByRole = _this.DocumentInstanceModel.getCompletionByRole(_this.document);
            }
        });
    };
    AdminViewDocumentInstanceController.prototype.getStatusBadgeClass = function (status) {
        var classes = {
            pending: "label-warning",
            in_progress: "label-info",
            completed: "label-success",
            archived: "label-default",
        };
        return classes[status] || "label-default";
    };
    AdminViewDocumentInstanceController.prototype.getStatusLabel = function (status) {
        var labels = {
            pending: "Pending",
            in_progress: "In Progress",
            completed: "Completed",
            archived: "Archived",
        };
        return labels[status] || status;
    };
    AdminViewDocumentInstanceController.prototype.getRoleLabel = function (role) {
        var labels = {
            student: "Student",
            guardian: "Guardian",
            instructor: "Instructor",
            staff: "Staff",
        };
        return labels[role] || role;
    };
    AdminViewDocumentInstanceController.prototype.getCompletionStatusLabel = function (status) {
        var labels = {
            pending: "Not Started",
            in_progress: "In Progress",
            completed: "Completed",
        };
        return labels[status] || status;
    };
    AdminViewDocumentInstanceController.prototype.formatDate = function (dateString) {
        if (!dateString)
            return "";
        var date = new Date(dateString);
        return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    };
    return AdminViewDocumentInstanceController;
}());
AdminViewDocumentInstanceController.$inject = [
    "$state",
    "$stateParams",
    "$uibModal",
    "DocumentInstanceModel",
    "FlashService",
    "UserService",
];
exports.default = AdminViewDocumentInstanceController;
